import { observable, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

export class AdminFeatureUsageStore extends LocalModel {
    @observable overview = { rows: [], total: 0, window: null, limitations: '' };
    @observable detail = null;
    @observable loading = false;
    @observable error = '';
    requestRevision = 0;

    constructor() {
        super('adminFeatureUsage', {
            namePlural: 'adminFeatureUsages',
            api: {},
        });
    }

    @action
    clearAll() {
        this.requestRevision += 1;
        this.overview = { rows: [], total: 0, window: null, limitations: '' };
        this.detail = null;
        this.loading = false;
        this.error = '';
    }

    async request(path) {
        const response = await util.fetchApi(`/api/featureusage${path}`, { method: 'GET' });
        if (response.status !== 200) {
            const error = new Error(response.message || 'Unable to load feature usage');
            error.status = response.status;
            throw error;
        }
        return response.data;
    }

    queryString(filters) {
        return new URLSearchParams(Object.entries(filters)
            .filter(([, value]) => value !== '' && value !== false && value !== undefined)
            .map(([key, value]) => [key, value === true ? '1' : String(value)])).toString();
    }

    async load(key, path) {
        const revision = ++this.requestRevision;
        this.updateKeyValue('loading', true);
        this.updateKeyValue('error', '');
        try {
            const result = await this.request(path);
            if (revision !== this.requestRevision) return;
            this.updateKeyValue(key, result);
        } catch (err) {
            if (revision !== this.requestRevision) return;
            if (err.status === 401 || err.status === 403) this.clearAll();
            this.updateKeyValue('error', err.message);
        } finally {
            if (revision === this.requestRevision) this.updateKeyValue('loading', false);
        }
    }

    loadOverview(feature, filters = {}) {
        const {
            days, search, unusedOnly, sort, offset,
        } = filters;
        const query = this.queryString({
            days, search, unusedOnly, sort, offset,
        });
        return this.load('overview', `/${feature}?${query}`);
    }

    loadDetail(feature, customerId, filters = {}) {
        this.updateKeyValue('detail', null);
        return this.load('detail', `/${feature}/${customerId}?${this.queryString({ days: filters.days })}`);
    }
}

export default new AdminFeatureUsageStore();
